import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDateTimePicker from "@mui/lab/MobileDateTimePicker";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { Controller } from "react-hook-form";
import FieldError from "shared/organisms/dynamicform/FieldError";

interface IDatePickerFieldProps {
  field: any;
  control: any;
  errors: any;
  getValues: any;
}

const DateTimePickerField2 = ({
  field,
  control,
  errors,
  getValues,
}: IDatePickerFieldProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Grid item {...field.breakpoints}>
      <Controller
        name={field.id}
        control={control}
        render={({ field: { onChange, value } }) => {
          const values = getValues();

          const handleChange = (selected: Date | null) => {
            if (!selected) return onChange(selected);

            const sanitizedDate = new Date(selected);
            sanitizedDate.setSeconds(0, 0);

            // end picker: if selected <= startTime, nudge to startTime + 1 min
            if (field.minDateTime && values[field.minDateTime]) {
              const startObj = new Date(values[field.minDateTime]);
              startObj.setSeconds(0, 0);
              const startTime = startObj.getTime();
              const selectedTime = sanitizedDate.getTime();

              if (selectedTime <= startTime) {
                const corrected = new Date(startTime);
                corrected.setMinutes(corrected.getMinutes() + 1);
                corrected.setSeconds(0, 0);
                return onChange(corrected);
              }
            }

            onChange(sanitizedDate);
          };

          const minDateTime: Date = field.minDateTime
            ? values[field.minDateTime]
              ? (() => {
                  const d = new Date(values[field.minDateTime]);
                  d.setMinutes(d.getMinutes() + 1);
                  return d;
                })()
              : (()=>{const d = new Date();
                  d.setMinutes(d.getMinutes() + 1);
                  return d;})()
            : new Date();

          const maxDateTime: Date | undefined =
            field.maxDateTime && isOpen && values[field.maxDateTime]
              ? new Date(values[field.maxDateTime])
              : undefined;

          return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <MobileDateTimePicker
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ width: "100%" }}
                    error={!!(errors && errors[field.id]?.message)}
                    required={field.required}
                    size="small"
                  />
                )}
                inputFormat="dd-MM-yyyy HH:mm"
                label={field.label}
                value={value || null}
                onChange={handleChange}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                minDateTime={minDateTime}
                maxDateTime={maxDateTime}
                disabled={field.disabled}
              />
            </LocalizationProvider>
          );
        }}
      />
      {errors && errors[field.id]?.message && (
        <FieldError field={field} errors={errors} />
      )}
    </Grid>
  );
};

export default DateTimePickerField2;
